export const QLEEntryIDQueryKey = 'qle-id'
export const QLETypeURLParam = ':qleType'

export enum QLEType {
  relocation = 'relo',
  addMember = 'add-member',
  removeMember = 'remove-member',
}

export const QLEModalKey = 'qle-annoucement'
